import { ChangeDetectionStrategy, Component, forwardRef, Input, ViewEncapsulation } from '@angular/core';
import { FiOptionsItemBase } from '@fi-shared/fi-options/fi-options-item-base';

@Component({
    selector: 'fi-options-item',
    template: `<button
        class="fi-options-item-wrapper"
        [ngClass]="{ selected: (selected$ | async) }"
        [disabled]="disabled"
        [attr.title]="title"
        tabindex="-1"
        mat-flat-button
        (click)="onClick()"
    >
        {{ title }}
    </button>`,
    styleUrls: ['./fi-options-item.component.scss'],
    host: { class: 'fi-options-item' },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: FiOptionsItemBase, useExisting: forwardRef(() => FiOptionsItemComponent) }],
    standalone: false,
})
export class FiOptionsItemComponent extends FiOptionsItemBase {
    @Input() title: string;
    @Input() disabled: boolean = false;
}
